import { Component } from "@angular/core";

@Component({
    selector: "clark-subscription",
    templateUrl: "./subscription.component.html",
    styleUrls: ["./subscription.component.scss"],
    standalone: true,
})
export class SubscriptionComponent {}
